import type { FC } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { isEmpty } from 'lodash-es';
import type { Option, SelectProps } from './Select';
import Select from './Select';

interface AdAccountSelectProps {
  /** Form field name the select is bound to. */
  name?: string;
  inputLabel?: string;
  options?: Option[];
  isLoading: boolean;
  onChange?: SelectProps['handleChange'];
}

const AdAccountSelect: FC<AdAccountSelectProps> = ({
  name = 'accountId',
  inputLabel = 'Ad Account',
  options,
  isLoading,
  onChange,
}) =>
  isLoading ? (
    <Skeleton
      data-testid="ad-account-select-skeleton"
      height={40}
      sx={{ transform: 'translateY(0)', borderRadius: '8px', width: '100%' }}
    />
  ) : (
    <Select
      name={name}
      inputLabel={inputLabel}
      disabled={isEmpty(options)}
      options={options ?? []}
      handleChange={onChange}
    />
  );

export default AdAccountSelect;
